import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  :root {
    ${({ theme }) => {
      let cssVariables = '';
      for (const [key, value] of Object.entries(theme)) {
        cssVariables += `${key}: ${value}; `;
      }
      return cssVariables;
    }}
  }

  body {
    margin: 0;
    padding: 0;
    background: var(--color-secondary);
    color: var(--text-color);
    transition: all 0.25s linear;
  }

  button {
    background: var(--highlight);
    color: var(--text-color);
    border: none;
    padding: 0.5rem 1rem;
    cursor: pointer;
    /* margin: 1rem; */
  }

  h3 {
    color: var(--text-color);
  }
`;
